import React from 'react';
import { createStyles, withStyles, Theme, CircularProgress, } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';

import styles from '../analytics/analytics.module.css';
import commonStyles from './common.module.css';
import { Moment } from 'moment';
import { MIN_DATE } from '../../utils/Analytics';
import Spinner from '../spinner/Spinner';

const materialStyles = (theme: Theme) =>
  createStyles({
    searchWrapperOuter: {
      top: '-133px',
    },
    inputLabel: {
      paddingBottom: 0,
    },
    inputLabelWrapper: {
      marginTop: 0,
    },
    inputLabelProgress: {
      marginTop: 15,
      width: 'auto',
    },
    progress: {
      animation: 'none'
    },
    '@media (max-width: 1200px)': {
      searchWrapperOuter: {
        right: '24px',
        transform: 'translateX(0)'
      }
    },
    '@media (max-width: 815px)': {
      ipBorder: {
        border: '1px solid var(--primaryblue)'
      },
      searchWrapperOuter: {
        top: '-110px',
        right: '50%',
        transform: 'translateX(50%)'
      }
    },
    '@media (max-width: 599px)': {
      searchWrapperOuter: {
        top: '-134px',
        width: '100%',
      }
    },
    '@media (max-width: 537px)': {
      searchWrapperOuter: {
        top: '-154px',
      }
    }
  });

interface AnalyticsFromToDateProps {
  classes: any;
  startDate: Moment;
  endDate: Moment;
  progress: boolean;
  handleChangeDate: (dateType: string, event: any) => void;
};

const AnalyticsFromToDate = (props: AnalyticsFromToDateProps) => {
  const { classes, startDate, endDate, progress } = props

  return (
    <div className={`${commonStyles.fMiddle} ${commonStyles.gap20} ${commonStyles.searchWrapperOuter} ${classes.searchWrapperOuter}`}>
      <div className={`${commonStyles.inputLabelWrapper} ${classes.inputLabelWrapper}`}>
        <label className={`${commonStyles.inputLabel} ${classes.inputLabel}`}>From</label>
        <KeyboardDatePicker
          autoOk
          value={startDate}
          format={'DD MMM YYYY'}
          onChange={(date) => props.handleChangeDate('startDate', date)}
          inputVariant="outlined"
          minDate={MIN_DATE}
          InputProps={{
            classes: { root: `${styles.brIp } ${classes.ipBorder }`},
          }}
        />
      </div>
      <div className={`${commonStyles.inputLabelWrapper} ${classes.inputLabelWrapper}`}>
        <label className={`${commonStyles.inputLabel} ${classes.inputLabel}`}>To</label>
        <KeyboardDatePicker
          autoOk
          value={endDate}
          format={'DD MMM YYYY'}
          onChange={(date) => props.handleChangeDate('endDate', date)}
          inputVariant="outlined"
          minDate={startDate}
          InputProps={{
            classes: { root: `${styles.brIp } ${classes.ipBorder }`},
          }}
        />
      </div>
      <div className={`${commonStyles.inputLabelWrapper} ${classes.inputLabelProgress}`}>
        {progress && (<CircularProgress size={25} className={classes.progress} />)}
      </div>
    </div>
  )
}

export default withStyles(materialStyles)(AnalyticsFromToDate)